/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentRegionOption
 */
export interface TournamentRegionOption {
    /**
     * Internal key (e.g., NA, EU, APAC)
     * @type {string}
     * @memberof TournamentRegionOption
     */
    key: string;
    /**
     * Display label (e.g., "North America", "Europe")
     * @type {string}
     * @memberof TournamentRegionOption
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentRegionOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentRegionOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentRegionOption interface.
 */
export function instanceOfTournamentRegionOption(value: object): value is TournamentRegionOption {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentRegionOptionFromJSON(json: any): TournamentRegionOption {
    return TournamentRegionOptionFromJSONTyped(json, false);
}

export function TournamentRegionOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentRegionOption {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentRegionOptionToJSON(json: any): TournamentRegionOption {
    return TournamentRegionOptionToJSONTyped(json, false);
}

export function TournamentRegionOptionToJSONTyped(value?: TournamentRegionOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

